import CONST_STORAGE from 'constants/storage';
import { signOut } from 'firebase/auth';
import { auth } from 'services/firebase';

import { SeatsInterface } from 'store/ducks/itineraries/types';
import { SEAT_FARE_KEY_BY_SEAT_TYPE } from 'common/lineForm.interface';
import { ItineraryListInterface } from 'pages/public/TicketSales/pages/TicketDetails';

export const setStorageStartStop = (item: string) =>
  localStorage.setItem(CONST_STORAGE.TICKET_SALES.STAR_STOP, item);

export const getStorageStartStop = () =>
  localStorage.getItem(CONST_STORAGE.TICKET_SALES.STAR_STOP) ||
  JSON.stringify([]);

export const setStorageEndStop = (item: string) =>
  localStorage.setItem(CONST_STORAGE.TICKET_SALES.END_STOP, item);

export const getStorageEndStop = () =>
  localStorage.getItem(CONST_STORAGE.TICKET_SALES.END_STOP) ||
  JSON.stringify([]);

export const setStorageUserToken = (item: string) =>
  localStorage.setItem(
    CONST_STORAGE.TICKET_SALES.CURRENT_USER_TOKEN,
    `Bearer ${item}`,
  );

export const getStorageUserToken = () =>
  localStorage.getItem(CONST_STORAGE.TICKET_SALES.CURRENT_USER_TOKEN) || '';

export const setStorageUserClaims = (item: string) =>
  localStorage.setItem(CONST_STORAGE.TICKET_SALES.CURRENT_USER_CLAIMS, item);

export const getStorageUserClaims = () =>
  localStorage.getItem(CONST_STORAGE.TICKET_SALES.CURRENT_USER_CLAIMS) ||
  JSON.stringify({});

export const setStorageLineList = (item: string) =>
  localStorage.setItem(CONST_STORAGE.TICKET_SALES.CURRENT_LINE_LIST, item);

export const getStorageLineList = () =>
  localStorage.getItem(CONST_STORAGE.TICKET_SALES.CURRENT_LINE_LIST) ||
  JSON.stringify([]);

export const handleLogout = (setCurrState: (item: boolean) => void) => {
  signOut(auth);

  setCurrState(false);
  localStorage.removeItem(CONST_STORAGE.TICKET_SALES.CURRENT_USER_TOKEN);
  localStorage.removeItem(CONST_STORAGE.TICKET_SALES.CURRENT_USER_CLAIMS);
};

export const getStorageLastPath = () =>
  localStorage.getItem(CONST_STORAGE.TICKET_SALES.LAST_PATH) || '';

export const setStorageLastPath = (item: string) =>
  localStorage.setItem(CONST_STORAGE.TICKET_SALES.LAST_PATH, item);

export const maxSeat = (seats: SeatsInterface[]) =>
  seats && seats.length > 0
    ? seats.reduce<number>(
        (max, seat) =>
          Math.max(max, typeof seat.seatType === 'number' ? seat.seatType : 0),
        0,
      )
    : 0;

export const calcSeatFare = (
  trip?: ItineraryListInterface | null,
  seatType?: number,
  holdTokens?: { fare: number; fareTax: number; isFree: boolean },
) => {
  if (trip) {
    const seatFare =
      trip?.seatFares?.[
        SEAT_FARE_KEY_BY_SEAT_TYPE[
          String(
            seatType ?? String(maxSeat(trip.seats.filter((e) => e.enabled))),
          ) as keyof typeof SEAT_FARE_KEY_BY_SEAT_TYPE
        ]
      ];
    if (holdTokens && seatFare) {
      if (seatFare?.type === 'FIXED_VALUE') {
        return Number(
          (
            seatFare?.value +
            holdTokens?.fare +
            holdTokens?.fareTax +
            (holdTokens?.isFree ? 0 : trip?.boardingTax || 0)
          ).toFixed(2),
        );
      } else {
        return Number(
          (
            (seatFare?.value * holdTokens?.fare) / 100 +
            holdTokens?.fare +
            holdTokens?.fareTax +
            (holdTokens?.isFree ? 0 : trip?.boardingTax || 0)
          ).toFixed(2),
        );
      }
    } else if (seatFare) {
      if (seatFare?.type === 'FIXED_VALUE') {
        return Number(
          (
            seatFare?.value +
            trip?.fare +
            trip?.fareTax +
            (trip?.boardingTax || 0)
          ).toFixed(2),
        );
      } else {
        return Number(
          (
            (seatFare?.value * trip?.fare) / 100 +
            trip?.fare +
            trip?.fareTax +
            (trip?.boardingTax || 0)
          ).toFixed(2),
        );
      }
    }
    return Number(
      trip?.fare + trip?.fareTax + (trip?.boardingTax || 0).toFixed(2),
    );
  }

  return 0;
};

export const holdTokensReduced = (
  list?: {
    holdToken?: string;
    tripScheduleSeatId?: string;
    profileId?: string;
    value?: number;
    floor?: number;
    type?: number;
    seatNumber?: number;
  }[],
) =>
  list
    ? Object.values(
        list?.reduce(
          (
            acc: { [key: string]: { key: string; passengers: number } },
            curr,
          ) => {
            if (curr.profileId) {
              if (acc[curr.profileId] === undefined) {
                acc[curr.profileId] = {
                  key: curr.profileId,
                  passengers: 1,
                };
              }
              acc[curr.profileId] = {
                key: curr.profileId,
                passengers: acc[curr.profileId].passengers + 1,
              };
            }
            return acc;
          },
          {},
        ),
      )
    : [];

export const validationLicense = (license: string) => {
  const regexLicense = /^[a-zA-Z]{3}[0-9]{4}$/;
  const regexLicenseMercosulCar = /^[a-zA-Z]{3}[0-9]{1}[a-zA-Z]{1}[0-9]{2}$/;
  const regexLicenseMercosulMotocycle = /^[a-zA-Z]{3}[0-9]{2}[a-zA-Z]{1}[0-9]{1}$/;

  if (
    regexLicense.test(license) ||
    regexLicenseMercosulCar.test(license) ||
    regexLicenseMercosulMotocycle.test(license)
  ) {
    return true;
  }
  return false;
};
